export default [
    {
        caption: '工具',
        id: 'tool',
        items: [
            {
                name: 'CDN 加速',
                id: '1',
                url: 'http://www.bootcdn.cn/',
                describe: '',
            }, {
                name: 'GUID 生成',
                id: '2',
                url: 'https://www.guidgenerator.com/online-guid-generator.aspx',
                describe: '',
            }, {
                name: 'JSON 格式化',
                id: '3',
                url: 'http://tool.chinaz.com/tools/jsonformat.aspx',
                describe: '',
            }, {
                name: 'Url Encode/Decode',
                id: '2',
                url: 'http://tool.chinaz.com/tools/urlencode.aspx',
                describe: '',
            },
            // {
            //     name: '流量研究院',
            //     id: '8',
            //     url: 'http://tongji.baidu.com/data/browser',
            //     describe: '',
            // },
            {
                name: 'Can I use',
                id: '9',
                url: 'https://caniuse.com/',
                describe: '',
            }, {
                name: '检测浏览器 ES6 支持情况',
                id: '10',
                url: 'http://ruanyf.github.io/es-checker/index.cn.html',
                describe: '',
            },
            // {
            //     name: '框架/类库流行趋势',
            //     id: '11',
            //     url: 'https://bestof.js.org/',
            //     describe: '',
            // },
        ]
    }, {
        caption: 'HTML',
        id: 'about-html',
        items: [
            {
                name: 'HTML to Jade',
                id: '1',
                url: 'http://html2jade.org/',
                describe: '',
            }, {
                name: 'HTML to Markdown',
                id: '2',
                url: 'https://domchristie.github.io/turndown/',
                describe: '',
            }, {
                name: 'Word to HTML',
                id: '3',
                url: 'https://word2cleanhtml.com/',
                describe: '',
            },
        ]
    }, {
        caption: 'CSS',
        id: 'about-css',
        items: [
            {
                name: 'Flexbox 代码生成',
                id: '1',
                url: 'http://the-echoplex.net/flexyboxes/',
                describe: '',
            }, {
                name: 'LESS to CSS',
                id: '2',
                url: 'http://lesscss.org/less-preview/',
                describe: '',
            }, {
                name: 'Sass Color Generator',
                id: '3',
                url: 'http://scg.ar-ch.org/',
                describe: '',
            },
        ]
    }, {
        caption: 'JavaScript',
        id: 'about-js',
        items: [
            {
                name: 'jQuery 源码查看',
                id: '5',
                url: 'https://j11y.io/jquery/#v=1.11.2',
                describe: '',
            }, {
                name: 'JavaScript 代码片段',
                id: '7',
                url: 'https://codepen.io/tag/rain/',
                describe: '',
            }, {
                name: 'You might not need jQuery',
                id: '12',
                url: 'http://youmightnotneedjquery.com/',
                describe: '',
            },
        ]
    },
]
